import React from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';
import { boostedJackpotStore } from '../../../../store/boostedJackpotStore';
import BoostedJackpotIconSliderBoard from './boostedJackpotIconSliderBoard';

const BoostedJackpotIconSliderBoardWrapper = observer(
  ({ containerConfigBoostedJackpotIconSliderBoard, boostedJackpotIconInfoBoardRectangle }) => {
    const { playerBoostedWinAmount, setPlayerBoostedWinAmount } = boostedJackpotStore;
    if (!playerBoostedWinAmount) {
      return null;
    }
    return (
      <Container {...containerConfigBoostedJackpotIconSliderBoard}>
        <BoostedJackpotIconSliderBoard
          playerBoostedWinAmount={playerBoostedWinAmount}
          setPlayerBoostedWinAmount={setPlayerBoostedWinAmount}
          boostedJackpotIconInfoBoardRectangle={boostedJackpotIconInfoBoardRectangle}
        />
      </Container>
    );
  }
);

export default BoostedJackpotIconSliderBoardWrapper;
